import {
  action, observable, flow, makeObservable,
} from 'mobx';
import reservationsAPI from '../api/reservations';
import BaseStore from './BaseStore';

class ReservationStore extends BaseStore {
  isReservationBusy = false;
  isReservationSending = false;
  reservations = [];

  getReservations = flow(function* () {
    this.isReservationBusy = true;

    try {
      const { data } = yield reservationsAPI.list();
      this.reservations = data;
    } catch (errors) {
      // eslint-disable-next-line no-console
      console.error(errors.response.data.errorMessages);
    } finally {
      this.isReservationBusy = false;
    }
  });

  cancelReservations = flow(function* (id) {
    try {
      return yield reservationsAPI.cancel(id);
    } catch (errors) {
      // eslint-disable-next-line no-console
      console.error(errors.response.data.errorMessages);
      return undefined;
    }
  });

  updateLaPosteReservation = flow(function* (id) {
    try {
      const { data } = yield reservationsAPI.updateLaPosteReservation(id);
      return data;
    } catch (errors) {
      // eslint-disable-next-line no-console
      console.error(errors.response.data.errorMessages);
      return undefined;
    }
  });

  getExamResult = async (id) => {
    try {
      await reservationsAPI.getExamResultDocument(id);
    } catch (errors) {
      // eslint-disable-next-line no-console
      console.error(errors.response.data.errorMessages);
    }
  };

  getConvocation = async (id) => {
    try {
      await reservationsAPI.getConvocationDocument(id);
    } catch (errors) {
      // eslint-disable-next-line no-console
      console.error(errors.response.data.errorMessages);
    }
  };

  getBill = async (id) => {
    try {
      await reservationsAPI.getBillDocument(id);
    } catch (errors) {
      // eslint-disable-next-line no-console
      console.error(errors.response.data.errorMessages);
    }
  };

  constructor() {
    super();

    makeObservable(this, {
      isReservationBusy: observable,
      isReservationSending: observable,
      reservations: observable,
      cancelReservations: action,
    });
  }
}

export default new ReservationStore();
